export enum EndorsementKey {
  ContractorsInstallationAndTools = 'contractorsInstallationAndTools',
  CyberCoverage = 'cyberCoverage',
  LimitDamagePremRented = 'limitDamagePremRented',
  EpliCoverage = 'epliCoverage',
  EquipmentBreakdownEndorsement = 'equipmentBreakdownEndorsement',
  HiredAutoAndNonOwnedAuto = 'hiredAutoAndNonOwnedAuto',
  LiquorLiabilityEndorsement = 'liquorLiabilityEndorsement',
  RestaurantCoverage = 'restaurantCoverage',
  WorkplaceViolenceCoverage = 'workplaceViolenceCoverage',
}

export interface EndorsementConfig {
  endorsementKey: EndorsementKey;
  label: string;
  description: string;
  recommended: boolean;
}
